export const CYCLE_CHANGE_REGEXP = /\d{1,2}:\d{2}\s*(?:am|AM)\s*[-|–]\s*\d{1,2}:\d{2}\s*(?:pm | PM)/

export const DEFAULT_TITLE = 'Appointment Summary'

export const INNER_PROPS = {
  popoverLinkProps: { capitalize: true },
  popoverInnerContentProps: { capitalize: true }
}

export const noSelectionError = 'Please review and make one or more selection(s) to proceed.'
